import { z } from 'zod'

export const schema = z.object({
  cottagePhones: z.array(
    z.object({
      prefix: z.string(),
      phoneNumber: z.string(),
    }),
  ),
})

export type schemaType = z.infer<typeof schema>

export const paramsSchema = z.object({
  slug: z.string(),
  province: z.string(),
})

export type paramsType = z.infer<typeof paramsSchema>

export type returnType = ApiServerResponse<schemaType>
